/**
 * Custom Parallax Functionality
 * 
 * translateRatio is what does the magic for calculating how much to translate.
 * That will need to be tweaked if the banner style translations are adjusted.
 */
(function($) {

    let arriveOptions = {
        onceOnly: true, // ensure that registered callbacks fire only once
        existing: true, // ensure that the registered callback is fired for the elements that already exist in the DOM and match the selector
    };
    let scaleFactorX = 1;
    let scaleFactorY = 1;

    let translateModifier = 1; // Get more aggressive parallax. Values over 1 are experimental
    let fullBleedBanner = '.wp-block-cd-full-bleed-banner';

    function bannerInViewport(initial) {
        let windowHeight = $(window).height();
        let bottomOfScreen = $(window).scrollTop() + windowHeight;
        let midScreen = $(window).scrollTop() + (windowHeight / 2);
        let topOfScreen = $(window).scrollTop();

        $(fullBleedBanner).each(function() {
            let bannerHeight = $(this).height();
            let bannerWidth = $(this).width();
            let halfSpan = (bannerHeight / 2) + (windowHeight / 2);
            let bannerTop = $(this).offset().top;
            let bannerBottom = $(this).offset().top + bannerHeight;
            let bannerHalf = $(this).offset().top + (bannerHeight / 2);
            let image = $(this).find('img');
            
            let imageWidth = image.get(0).naturalWidth;
            let imageHeight = image.get(0).naturalHeight;

            let imgRatio = imageHeight / imageWidth;
            let containerRatio = bannerHeight / bannerWidth;
            
            let finalHeight = 0;
            let finalWidth = 0;

            if( containerRatio > imgRatio ) {
                finalHeight = bannerHeight;
                finalWidth = bannerHeight / imgRatio;
            } else {
                finalWidth = bannerWidth;
                finalHeight = bannerWidth * imgRatio;
            }

            scaleFactorX = finalWidth / bannerWidth;
            scaleFactorY = finalHeight / bannerHeight;

            let scaleSpace = (imageHeight - bannerHeight) / 2;
            let translateFactor = (scaleSpace / imageHeight) * (100 * translateModifier);

            if( initial ) {
                image.css('transform', 'scale(' + scaleFactorX + ', ' + scaleFactorY + ') translateY(-' + translateFactor + '%) translateZ(-1px)');
                $(this).addClass('loaded');
            }

            if ((bottomOfScreen > bannerTop) && (topOfScreen < bannerBottom)){
                // Want range to be a little less
                let translateRatio = ((midScreen - bannerHalf) / halfSpan) * translateFactor;

                if( midScreen > bannerHalf ) {
                    image.css('transform', 'scale(' + scaleFactorX + ', ' + scaleFactorY + ') translateY(' + translateRatio + '%) translateZ(-1px)');
                } else if( midScreen === bannerHalf ) {
                    image.css('transform', 'scale(' + scaleFactorX + ', ' + scaleFactorY + ') translateY(0%) translateZ(-1px)');
                } else {
                    image.css('transform', 'scale(' + scaleFactorX + ', ' + scaleFactorY + ') translateY(' + translateRatio + '%) translateZ(-1px)');
                }
                

            } else {
                // Out of viewport
            }

        });
    }

    // Once Banner is Ready in DOM
    $(document).arrive(fullBleedBanner, arriveOptions, bannerInViewport(true));

    // On Fully Loaded. Catch all for possibly not loaded images
    $(window).on('load', function() {
        bannerInViewport(true); 
    });

    // ON SCROLL
    $(window).scroll(function() {
        bannerInViewport();
    });

    // ON RESIZE
    $(window).resize(function() {
        bannerInViewport();
    });

})(jQuery);